import React, { useEffect } from 'react';

// Load Ionicons web components once
let loaded = false;
function loadIonicons() {
  if (loaded) return;
  loaded = true;
  import('ionicons/icons');

  // Define custom elements from ionicons
  if (!customElements.get('ion-icon')) {
    import('ionicons').then((mod) => {
      if (mod.defineCustomElements) {
        mod.defineCustomElements(window);
      }
    });
  }
}

/**
 * Wrapper for Ionicons web component.
 * Uses the exact same icon names as the Budge React Native app.
 *
 * Usage: <IonIcon name="swap-horizontal" size={28} color="#1A6B4A" />
 */
function IonIcon({ name, size = 24, color, style = {}, className = '' }) {
  useEffect(() => {
    loadIonicons();
  }, []);

  return (
    <ion-icon
      name={name}
      class={className}
      style={{
        fontSize: `${size}px`,
        color: color || 'inherit',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    />
  );
}

export default IonIcon;
